import { LoadingStates } from '@pb/utils'

export default {
  registerFormStatus: LoadingStates.NotLoaded,
  registerFormErrors: [],
  redirectUrl: '',
  shouldShowAdditionalInfoConsent: false,
}
